import { ENotificationsActions, NotificationsActions } from "@edp-store/actions/notifications.actions";
import { initialNotificationsState, INotificationsState } from "@edp-store/state/notifications.state";

export function notificationsReducers(state = initialNotificationsState, action: NotificationsActions): INotificationsState {
    switch (action.type) {
        case ENotificationsActions.SaveOptOut: {
            return {
                ...state,
                optOut: action.payload,
            };
        }
        case ENotificationsActions.SaveDevice: {
            return {
                ...state,
                device: action.payload,
            };
        }
        case ENotificationsActions.SetPushConfigs: {
            return {
                ...state,
                pushConfigs: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
